// api
import acceptQuoteAPICall from './api/acceptQuote';
import rejectQuoteAPICall from './api/rejectQuote';
import getQuoteDetailAPICall from './api/getQuoteDetail';
// settings
import moment from 'moment';

//
//
//
//
//
//
// utils
//
//
//
//
//
//
//

const deepCopy = (object) => JSON.parse(JSON.stringify(object));

const navigateToList = async ({ history }) => {
  history.push('/emergencies/');
};

const utils = {
  deepCopy,
  navigateToList,
};

//
//
//
//
//
//
// business
//
//
//
//
//
//
//

const canQuoteBeEdited = (ticket) => {
  if (!!!ticket) return false;
  const state = ticket.synthetic_state;
  const statesThatCanEdit = ['QUOTE_SENT'];
  return statesThatCanEdit.includes(state);
};

const bussiness = { canQuoteBeEdited };

//
//
//
//
//
//
// data transformation
//
//
//
//
//
//
//

const cleanNumberForBackend = (numberInStringFormat) => {
  if (!numberInStringFormat) return 0;
  if (numberInStringFormat === '') return 0;
  return parseFloat(numberInStringFormat) || 0;
};

const prepareTimeForBackend = (time) => {
  if (time.length === 5) return `${time}:00`;
  return time;
};

const getDatetimeFromSeparateDateAndTime = ({ date, time }) => {
  if (time === '' || date === '') return '';
  const timeParts = time.split(':');
  const hours = timeParts[0];
  const minutes = timeParts[1];
  const dateTime = moment(date).hours(hours).minutes(minutes);
  const dateTimeInIsoFormat = dateTime.toISOString();
  return dateTimeInIsoFormat;
};

const getQuoteDtoFromFormValuesAndTicket = ({ values, ticketDto }) => {
  const copyTicketDto = deepCopy(ticketDto);
  const dto = {
    order_data: {
      pickup: copyTicketDto.order_data.pickup,
      dropoff: copyTicketDto.order_data.dropoff,
      service_type: copyTicketDto.order_data.service_type,
      loads_data: copyTicketDto.order_data.loads_data,
    },
  };

  // proposed date and times
  dto.order_data.pickup.date = values.order_data.pickup.date;
  dto.order_data.pickup.time_from = prepareTimeForBackend(
    values.order_data.pickup.time_from
  );
  dto.order_data.pickup.time_to = prepareTimeForBackend(
    values.order_data.pickup.time_to
  );
  dto.order_data.dropoff.date = values.order_data.dropoff.date;
  dto.order_data.dropoff.time_from = prepareTimeForBackend(
    values.order_data.dropoff.time_from
  );
  dto.order_data.dropoff.time_to = prepareTimeForBackend(
    values.order_data.dropoff.time_to
  );

  //   price
  dto.price = {
    amount: values.price.amount,
    currency: values.price.currency,
  };

  dto.suggested_price = {
    amount: values.suggested_price.amount,
    currency: values.suggested_price.currency,
  };

  dto.price_suggestion_id = values.price_suggestion_id;

  dto.operation_details = {
    carrier: values.operation_details.carrier,
    cost: {
      amount: cleanNumberForBackend(values.operation_details.cost),
      currency: values.price.currency,
    },
    details: values.operation_details.details,
  };

  //  expires at
  const expiresAtDate = values.expiration_date;
  const expiresAtTime = values.expiration_time;
  const expires_at = getDatetimeFromSeparateDateAndTime({
    date: expiresAtDate,
    time: expiresAtTime,
  });
  if (expires_at !== '' && expires_at !== null) dto.expires_at = expires_at;

  dto.conditions = values.conditions;

  return dto;
};

const getPriceSuggestionDTO = ({ ticketDetail, values }) => {
  const input = {
    shipper_data: { ...ticketDetail.shipper_data },
    order_data: { ...ticketDetail.order_data },
    currency: values.price.currency,
  };
  input.order_data.pickup = {
    ...input.order_data.pickup,
    ...values.order_data.pickup,
  };
  input.order_data.dropoff = {
    ...input.order_data.dropoff,
    ...values.order_data.dropoff,
  };
  const dto = { input };
  if (
    input.order_data.pickup.date === '' ||
    input.order_data.dropoff.date === ''
  )
    return null;
  return dto;
};

const dataTransformation = {
  getQuoteDtoFromFormValuesAndTicket,
  getPriceSuggestionDTO,
  cleanNumberForBackend,
};

//
//
//
//
//
//
// callBackend
//
//
//
//
//
//
//

// calls api to accept a Quote
const acceptQuote = async ({ quoteId, ticketId }) => {
  return acceptQuoteAPICall({ quoteId, ticketId });
};

// calls api to reject a Quote
const rejectQuote = async ({ quoteId, ticketId, feedBackDTO }) => {
  return rejectQuoteAPICall({ quoteId, ticketId, feedBackDTO });
};

// calls api to get a QuoteDetail
const getQuoteDetail = async ({ quoteId, ticketId }) => {
  return getQuoteDetailAPICall({ quoteId, ticketId });
};

const callBackend = {
  acceptQuote,
  rejectQuote,
  getQuoteDetail,
};

//
//
//
//
//
//
// quoteService
//
//
//
//
//
//
//

const quoteService = {
  utils,
  bussiness,
  dataTransformation,
  callBackend,
};

export default quoteService;
